var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('swiper',{key:_vm.data_key,attrs:{"slides-per-view":3,"space-between":30,"breakpoints":{
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 50,
            },
        },"loop":false},on:{"swiper":_vm.onSwiper,"slideChange":_vm.onSlideChange}},_vm._l((_vm.data),function(badge){return _c('swiper-slide',{key:badge.id},[_c('div',{staticClass:"text-center hero-badge",staticStyle:{"height":"160px","width":"160px"}},[(badge.achievement.deck_count > 1)?_c('div',{staticClass:"hero-badge__counter"},[_c('span',[_vm._v(_vm._s(badge.achievement.deck_count)+"x")])]):_vm._e(),_c('img',{staticStyle:{"object-fit":"contain","width":"136px","height":"136px"},attrs:{"src":badge.achievement.image,"alt":badge.achievement.title}}),_c('div',{staticClass:"badge-ribbon"},[_c('div',{staticClass:"badge-ribbon__title"},[_vm._v(_vm._s(badge.achievement.title))])])])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }